<template>
	<div>
		<div class="text-center">
			<TnButton
				tertiary
				@click="writeReviewModal = true"
			>
				Skriv en anmeldelse
			</TnButton>
		</div>
		<Modal v-model="writeReviewModal">
			<SelfServiceWizardStep>
				<template #headline>
					<h2>Din anmeldelse av {{ product.title }}</h2>
				</template>
				<template #main>
					<div class="text-left">
						<div class="total margin-bottom-l">
							<label>Totalvurdering</label>
							<TnRating
								:rating="review.Rating"
								@update:modelValue="review.Rating = $event"
								interactive
								size="xl"
								label
							/>
						</div>
						<div class="margin-bottom-xl">
							<TnTextField
								label="Tittel på omtale"
								placeholder="Eksempel: Gode funksjoner!"
								required
								:key="getError('reviewtitle') ? 1 : 0"
								v-model="review.Title"
								size="m"
							>
								<template
									v-if="getError('reviewtitle')"
									#error
								>
									{{ getError("reviewtitle") }}
								</template>
							</TnTextField>
						</div>
						<div class="margin-bottom-xl">
							<TnTextArea
								label="Beskrivelse"
								v-model="review.ReviewText"
								required
								size="m"
							>
								<template
									v-if="isReviewTextError"
									#error
								>
									{{ reviewTextValidationText }}
								</template>
							</TnTextArea>
						</div>
						<div>
							<TnRadiobuttonGroup
								class="radiobutton-group"
								label="Ville du anbefalt dette produktet til venn?"
								size="l"
								inline
								:options="[
									{ label: 'Ja', value: modelValue },
									{ label: 'Nei', value: modelValue },
								]"
								v-model="review.IsRecommended"
								required
							/>
						</div>
						<div class="margin-bottom-xl">
							<TnTextField
								label="Kallenavn"
								placeholder="Eksempel: bob27"
								required
								:key="getError('usernickname') ? 1 : 0"
								v-model="review.UserNickname"
								size="m"
							>
								<template
									v-if="getError('usernickname')"
									#error
								>
									{{ getError("usernickname") }}
								</template>
							</TnTextField>
						</div>
						<div class="margin-bottom-xl">
							<TnTextField
								label="E-postadresse"
								placeholder="Eksempel: dineepost@eksempel.no"
								required
								v-model="review.UserEmail"
								size="m"
							>
								<template
									v-if="isEmailError"
									#error
								>
									{{ emailValidationText }}
								</template>
							</TnTextField>
						</div>
						<div>
							<div
								class="rating-category"
								v-for="(question, key) in reviewQuestions"
								:key="key"
							>
								<div>{{ question }}</div>
								<div>
									<TnRating
										:rating="review[key]"
										@update:modelValue="review[key] = $event"
										interactive
										size="l"
										label
									></TnRating>
								</div>
							</div>
						</div>
						<!-- <div class="rating-category">
							<div>Hvordan er levetiden på batteriet?</div>
							<div>
								<TnRating
									:rating="review.Rating_BatteryLife"
									@input="review.Rating_BatteryLife = $event"
									interactive
									size="l"
									label
								></TnRating>
							</div>
						</div>
						<div class="rating-category">
							<div>Synes du produktet er enkelt å bruke?</div>
							<div>
								<TnRating
									:rating="review.Rating_EaseOfUse"
									@input="review.Rating_EaseOfUse = $event"
									interactive
									size="l"
									label
								></TnRating>
							</div>
						</div>
						<div class="rating-category">
							<div>Hva synes du om designet på produktet?</div>
							<div>
								<TnRating
									:rating="review.Rating_Design"
									@input="review.Rating_Design = $event"
									interactive
									size="l"
									label
								></TnRating>
							</div>
						</div>
						<div class="rating-category">
							<div>Hva synes du om kvaliteten på kameraet?</div>
							<div>
								<TnRating
									:rating="review.Rating_PictureQuality"
									@input="review.Rating_PictureQuality = $event"
									interactive
									size="l"
									label
								></TnRating>
							</div>
						</div>
						<div class="rating-category">
							<div>Hva synes du om skjermen?</div>
							<div>
								<TnRating
									:rating="review.Rating_Skjerm"
									@input="review.Rating_Skjerm = $event"
									interactive
									size="l"
									label
								></TnRating>
							</div>
						</div> -->
						<!-- Not working right now, see if we need this or not -->
						<!-- <div class="margin-top-l">
							<div>
								<TnRadiobuttonGroup
									class="radiobutton-group"
									label="Hvor fornøyd er du med dekningen til Telenor?"
									size="s"
									inline
									:options="coverageOptions"
									v-model="coverageSelection"
								/>
							</div>
						</div> -->
					</div>
				</template>

				<template #actions>
					<TnButton
						:disabled="!valid || submitting"
						:loading="submitting"
						@click="submit"
						block
						>Send omtale
					</TnButton>
					<div class="margin-top-s small-text">Du vil bli varslet på e-post når spørsmålet ditt blir besvart.</div>
				</template>
			</SelfServiceWizardStep>
		</Modal>
	</div>
</template>

<script>
import { mapState } from "vuex";
import bazaarvoiceIntegration from "~/components/ecommerce/ECommerceProductDetails/bazaarvoice-integration";
import validateEmail from "@/helpers/validation/validateEmail";
import { ProductCategory } from "~/components/ecommerce/types/ProductCategory";

const initLastResult = () => {
	return {
		FormErrors: {
			FieldErrors: {
				reviewtext: {},
				usernickname: {},
			},
		},
	};
};

const mobile = {
	Rating_BatteryLife: "Hvordan er levetiden på batteriet?",
	Rating_PictureQuality: "Hva synes du om kvaliteten på kameraet?",
	Rating_Skjerm: "Hva synes du om skjermen?",
	Rating_Design: "Hva synes du om designet på produktet?",
	Rating_EaseOfUse: "Synes du produktet er enkelt å bruke?",
};

const general = {
	Rating_Quality: "Hvordan vurderer du kvaliteten på dette produktet?",
	Rating_Design: "Hva synes du om designet på produktet?",
	Rating_EaseOfUse: "Synes du produktet er enkelt å bruke?",
};

export default defineNuxtComponent({
	name: "WriteReviewModal",

	computed: {
		...mapState("ecommerce", ["product"]),
		isMobileReview() {
			const mobileCategories = [ProductCategory.PHONE, ProductCategory.WATCH, ProductCategory.TABLET];
			return mobileCategories.includes(this.productCategory);
		},
		reviewQuestions() {
			return this.isMobileReview ? this.mobile : this.general;
		},
		valid() {
			if (this.isEmailError || this.isReviewTextError) {
				return false;
			}
			return (
				// this.coverageSelection &&
				Object.keys(this.review)
					.map((key) => this.review[key])
					.every((x) => x !== 0 && x !== "" && x !== undefined)
			); // All keys must have a value
		},
		fieldErrors() {
			return this.lastResult?.FormErrors.FieldErrors;
		},
		reviewApiModel() {
			return {
				...this.review,
				SendEmailAlertWhenPublished: true,
				// [this.coverageSelection]: true,
			};
		},
	},

	props: ["productCategory"],

	data() {
		return {
			writeReviewModal: false,
			submitting: false,
			review: {
				Rating: 0,
				Title: "",
				ReviewText: "",
				IsRecommended: undefined,
				UserNickname: "",
				UserEmail: "",
			},
			lastResult: initLastResult(),
			coverageSelection: "",
			coverageOptions: [
				{
					label: "Veldig fornøyd",
					value: "tagid_Dekning_1/VeldigFornyd",
				},
				{
					label: "Fornøyd",
					value: "tagid_Dekning_1/Fornyd",
				},
				{
					label: "Verken eller",
					value: "tagid_Dekning_1/VerkenEller",
				},
				{
					label: "Misfornøyd",
					value: "tagid_Dekning_1/Misfornyd",
				},
				{
					label: "Veldig misfornøyd",
					value: "tagid_Dekning_1/VeldigMisfornyd",
				},
			],
			isReviewTextError: false,
			reviewTextValidationText: "",
			isEmailError: false,
			emailValidationText: "",
			mobile,
			general,
		};
	},

	watch: {
		"review.UserEmail": function handler(value) {
			this.isEmailError = !validateEmail(value);
			this.emailValidationText = "Ugyldig E-post";
		},
		"review.ReviewText": function handler(value) {
			const minLength = 100;
			if (value.trim().length < minLength && value.trim().length > 0) {
				this.isReviewTextError = true;
				this.reviewTextValidationText = `Skriv minimum ${minLength - value.trim().length} tegn til.`;
			} else {
				this.isReviewTextError = false;
			}
		},
	},

	methods: {
		async submit() {
			this.submitting = true;
			this.lastResult = initLastResult();
			try {
				const result = await bazaarvoiceIntegration(5).postReview(this.product?.bazaarVoiceId, this.reviewApiModel);
				this.lastResult = result;
			} catch (err) {
				console.log(err);
			} finally {
				this.submitting = false;
				if (!this.lastResult.HasErrors) {
					this.writeReviewModal = false;
				}
			}
		},
		getError(fieldName) {
			const NORWEGIAN_ERRORS = {
				ERROR_FORM_DUPLICATE: "Dette navnet er allerede tatt. Vennligst velg et annet",
				ERROR_FORM_TOO_SHORT: "Teksten er for kort",
			};

			const resolved = this.fieldErrors?.[fieldName];

			if (resolved) {
				return NORWEGIAN_ERRORS[resolved.Code] || resolved.Message;
			}
		},
	},

	mounted() {
		if (this.productCategory) {
			let ratings;
			if (this.isMobileReview) {
				ratings = Object.keys(this.mobile);
			} else {
				ratings = Object.keys(this.general);
			}
			const result = ratings.reduce((obj, rating) => {
				obj[rating] = 0;
				return obj;
			}, {});
			this.review = {
				...result,
				Rating: 0,
				Title: "",
				ReviewText: "",
				IsRecommended: undefined,
				UserNickname: "",
				UserEmail: "",
			};
		}
	},
});
</script>

<style lang="scss" scoped>
.total {
	display: flex;

	label {
		font-weight: bold;
		margin-right: $spacing-m;
	}
}

.rating-category {
	margin-bottom: $spacing-l;
	font-weight: bold;

	> div:first-child {
		margin-bottom: $spacing-s;
	}
}

.small-text {
	color: $color-neutrals-600-shade;

	@include font-text-s;
}

.radiobutton-group {
	margin-bottom: $spacing-l;

	:deep(.radiobutton input) {
		position: relative;
	}
}
</style>
